import React from "react";

import {Create} from "react-admin";
import PageForm from "./PageForm";

const PageCreate = (props) => (
    <Create {...props}><PageForm/></Create>
);

export default PageCreate;
